import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {ScreenSizeProvider} from '@github-ui/screen-size'

import {BaseUrlContextProvider} from './contexts/BaseUrlContext'

const appName = 'react-activity-view'
const category = ''
const metadata = {}

export function App({children}: {children?: React.ReactNode}) {
  return (
    <ScreenSizeProvider>
      <BaseUrlContextProvider baseUrl="">
        <AnalyticsProvider appName={appName} category={category} metadata={metadata}>
          {children}
        </AnalyticsProvider>
      </BaseUrlContextProvider>
    </ScreenSizeProvider>
  )
}

try{ App.displayName ||= 'App' } catch {}